module.exports = __WEBPACK_EXTERNAL_MODULE_164__;


//////////////////
// WEBPACK FOOTER
// external "gemini/pinning/PinsPanel"
// module id = 164
// module chunks = 2